import React from 'react';
import { HeroSection } from './components/HeroSection';
import { DiagnosisSection } from './components/DiagnosisSection';
import { SystemSection } from './components/SystemSection';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <main className="min-h-screen bg-carbon font-body text-white selection:bg-gold selection:text-carbon" data-id="element-0">
      <HeroSection data-id="element-1" />
      <DiagnosisSection data-id="element-2" />
      <SystemSection data-id="element-3" />
      <FinalCTA data-id="element-4" />
    </main>;
}